import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomInternalServerComponent } from './custom-internal-server.component';
import { I18nModule } from '@spartacus/core';

@NgModule({
  declarations: [CustomInternalServerComponent],
  imports: [
    CommonModule,
    I18nModule
  ]
})
export class CustomInternalServerModule { }
